$(function() {
  $('.product-detail .qty-btn').click(function(){
    const input = $(this).siblings('#quantity');
    if ($(this).attr('id') === 'plus') {
      input.get(0).value++
    }
    if ($(this).attr('id') === 'minus' && input.val() > 1) {
      input.get(0).value--
    }
  });
  $('#thumbnails a').click(function() {
    var newImage = $(this).attr('href');
    $( '#ProductPhotoImg' ).attr({ src: newImage });
    return false;
  });
});
$(function() {
  setBanner();
  $(window).on('resize', function() {
    setBanner();
  })
  function setBanner() {
    var image = '';
    var minHeight = 0;
    if(window.innerWidth < 767){
      image = $('.banner#home-banner').data('image-mobile');
      // image height minus the half the book cover height
      minHeight = ($(window).width()/375 * 686) - ($('.book-image').height()/2);
    } else {
      image = $('.banner#home-banner').data('image-desktop');
      minHeight = 350
    }
    $('.banner#home-banner').css('background-image', 'url('+ image +')');
    $('.banner#home-banner .title').css('min-height', minHeight);
  }
});